
/*
export async function LOGIN({commit}, {login, password}) {
}
*/
